(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sierro-accessories"]) return;
  try {
    
  document.querySelectorAll('[data-sierro-accessories]').forEach((section) => {
    const filters = Array.from(section.querySelectorAll('[data-accessory-filter]'));
    const cards = Array.from(section.querySelectorAll('[data-accessory-card]'));

    filters.forEach((filter) => {
      filter.addEventListener('click', () => {
        const value = filter.dataset.accessoryFilter;
        filters.forEach((item) => item.setAttribute('aria-pressed', item === filter ? 'true' : 'false'));
        cards.forEach((card) => {
          const compatibility = card.dataset.compatibility;
          card.hidden = value !== 'all' && compatibility !== value && compatibility !== 'both';
          if (value === 'both') card.hidden = compatibility !== 'both';
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sierro-cart-conversion"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const bindAttribution = (scope = document) => {
      scope.querySelectorAll('[data-sierro-cart-attribution]').forEach((container) => {
        const select = container.querySelector('[data-sierro-cart-source]');
        const status = container.querySelector('[data-sierro-cart-source-status]');
        if (!select || !status || select.dataset.sierroBound === 'true') return;

        select.dataset.sierroBound = 'true';
        select.addEventListener('change', async () => {
          select.disabled = true;
          status.hidden = false;
          status.textContent = select.dataset.savingMessage;

          try {
            const root = window.Shopify?.routes?.root || '/';
            const response = await fetch(`${root}cart/update.js`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json'
              },
              body: JSON.stringify({
                attributes: {
                  'How did you hear about Sierro?': select.value
                }
              })
            });

            if (!response.ok) throw new Error('Cart attribute update failed');
            status.textContent = select.dataset.savedMessage;
          } catch (error) {
            status.textContent = select.dataset.errorMessage;
          } finally {
            select.disabled = false;
          }
        });
      });
    };

    bindAttribution();

    if (window.sierroCartConversionRefreshBound) return;
    window.sierroCartConversionRefreshBound = true;

    document.addEventListener('cart:bundled-sections', (event) => {
      document.querySelectorAll('[data-sierro-cart-conversion][data-section-id]').forEach((section) => {
        const sectionId = section.dataset.sectionId;
        if (sectionId && !event.detail.sections.includes(sectionId)) {
          event.detail.sections.push(sectionId);
        }
      });
    });

    document.addEventListener('cart:updated', (event) => {
      const sections = event.detail?.cart?.sections;
      if (!sections) return;

      document.querySelectorAll('[data-sierro-cart-conversion][data-section-id]').forEach((currentSection) => {
        const sectionId = currentSection.dataset.sectionId;
        const updatedMarkup = sections[sectionId];
        if (typeof updatedMarkup !== 'string') return;

        const parsed = new DOMParser().parseFromString(updatedMarkup, 'text/html');
        const updatedSection = parsed.querySelector(`[data-sierro-cart-conversion][data-section-id="${sectionId}"]`);

        if (!updatedSection) {
          currentSection.remove();
          return;
        }

        currentSection.replaceWith(updatedSection);
        bindAttribution(updatedSection);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sierro-cart-shipping-note"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.sierroCartShippingNoteRefreshBound) return;
    window.sierroCartShippingNoteRefreshBound = true;

    const selector = '[data-sierro-cart-shipping-note][data-section-id]';
    let refreshSequence = 0;

    const parseSection = (markup, sectionId) => {
      if (typeof markup !== 'string') return null;
      const parsed = new DOMParser().parseFromString(markup, 'text/html');
      return parsed.querySelector(`${selector}[data-section-id="${CSS.escape(sectionId)}"]`);
    };

    const refresh = async (sections = null) => {
      const sequence = ++refreshSequence;
      const currentSections = Array.from(document.querySelectorAll(selector));

      await Promise.all(currentSections.map(async (currentSection) => {
        try {
          const sectionId = currentSection.dataset.sectionId;
          if (!sectionId) return;

          let markup = sections?.[sectionId];

          if (typeof markup !== 'string') {
            const root = window.Shopify?.routes?.root || '/';
            const response = await fetch(`${root}cart?section_id=${encodeURIComponent(sectionId)}`);
            if (!response.ok) return;
            markup = await response.text();
          }

          if (sequence !== refreshSequence) return;

          const updatedSection = parseSection(markup, sectionId);
          if (updatedSection) currentSection.replaceWith(updatedSection);
        } catch {
          return;
        }
      }));
    };

    document.addEventListener('cart:bundled-sections', (event) => {
      const sections = event.detail?.sections;
      if (!Array.isArray(sections)) return;

      document.querySelectorAll(selector).forEach((section) => {
        const sectionId = section.dataset.sectionId;
        if (sectionId && !sections.includes(sectionId)) sections.push(sectionId);
      });
    });

    document.addEventListener('cart:updated', (event) => {
      refresh(event.detail?.cart?.sections);
    });

    document.addEventListener('cart:refresh', () => {
      refresh();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sierro-header"]) return;
  try {
    
  (() => {
    const draftRouteMap = {
      '/products/sierro-1000': '/pages/terms?view=sierro-1000-demo',
      '/products/sierro-2000': '/pages/terms?view=sierro-2000-demo',
      '/pages/about-us': '/pages/terms?view=about-us',
      '/pages/product-registration': '/pages/register?view=product-registration',
      '/pages/register': '/pages/register?view=product-registration',
      '/pages/warranty-policy': '/pages/terms?view=warranty-policy',
      '/pages/shipping-policy': '/pages/terms?view=shipping-policy',
      '/pages/privacy-policy': '/pages/policy?view=privacy-policy',
      '/pages/terms-of-service': '/pages/terms?view=terms-of-service'
    };

    const applyDraftRoutes = () => {
      if (!window.Shopify?.theme || window.Shopify.theme.role === 'main') return;

      document.querySelectorAll('a[href]').forEach((link) => {
        const url = new URL(link.href, window.location.origin);
        const draftHref = draftRouteMap[url.pathname];
        if (draftHref) link.href = draftHref;
      });
    };

    applyDraftRoutes();
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', applyDraftRoutes, { once: true });
    }

    const headers = document.querySelectorAll('[data-sierro-header]');

    headers.forEach((header) => {
      if (header.dataset.sierroHeaderReady === 'true') return;
      header.dataset.sierroHeaderReady = 'true';

      const wrapper = header.closest('.shopify-section');
      const menu = header.querySelector('[data-sierro-mobile-menu]');
      const openButton = header.querySelector('[data-sierro-menu-open]');
      const closeButtons = header.querySelectorAll('[data-sierro-menu-close]');
      const drawer = menu?.querySelector('.sierro-mobile-menu__panel');
      const desktopProducts = header.querySelector('[data-sierro-products-menu]');
      let closeTimer;

      wrapper?.classList.add('sierro-header-wrapper');

      const updateHeaderHeight = () => {
        document.documentElement.style.setProperty('--sierro-header-height', `${header.offsetHeight}px`);
      };

      const updateHeaderState = () => {
        header.classList.toggle('is-scrolled', window.scrollY > 12);
        window.requestAnimationFrame(updateHeaderHeight);
      };

      const openMenu = () => {
        if (!menu || !openButton) return;
        window.clearTimeout(closeTimer);
        menu.hidden = false;
        document.body.classList.add('sierro-menu-open');
        openButton.setAttribute('aria-expanded', 'true');
        window.requestAnimationFrame(() => {
          menu.classList.add('is-open');
          menu.querySelector('[data-sierro-menu-close]:not(.sierro-mobile-menu__backdrop)')?.focus();
        });
      };

      const closeMenu = (restoreFocus = true) => {
        if (!menu || !openButton || menu.hidden) return;
        menu.classList.remove('is-open');
        document.body.classList.remove('sierro-menu-open');
        openButton.setAttribute('aria-expanded', 'false');
        closeTimer = window.setTimeout(() => {
          menu.hidden = true;
          if (restoreFocus) openButton.focus();
        }, 220);
      };

      openButton?.addEventListener('click', openMenu);
      closeButtons.forEach((button) => button.addEventListener('click', () => closeMenu()));

      menu?.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          closeMenu();
          return;
        }

        if (event.key !== 'Tab' || !drawer) return;
        const focusable = Array.from(
          drawer.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])')
        );
        if (focusable.length === 0) return;

        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      });

      window.addEventListener('resize', () => {
        if (window.innerWidth > 760) closeMenu(false);
        updateHeaderState();
      }, { passive: true });
      window.addEventListener('scroll', updateHeaderState, { passive: true });
      header.querySelector('.sierro-site-header__inner')?.addEventListener('transitionend', updateHeaderHeight);

      document.addEventListener('click', (event) => {
        if (desktopProducts?.open && !desktopProducts.contains(event.target)) {
          desktopProducts.open = false;
        }
      });

      desktopProducts?.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && desktopProducts.open) {
          desktopProducts.open = false;
          desktopProducts.querySelector('summary')?.focus();
        }
      });

      updateHeaderState();

      if (document.body.classList.contains('template-cart')) {
        document.querySelectorAll('#MainContent .cart.is-empty a[href="/collections/all"]').forEach((link) => {
          link.href = '/#sierro-products';
          const label = link.querySelector('.btn-text');
          if (label) {
            const textNode = Array.from(label.childNodes).find((node) => node.nodeType === Node.TEXT_NODE && node.textContent.trim());
            if (textNode) textNode.textContent = 'Browse Sierro';
          } else {
            link.textContent = 'Browse Sierro';
          }
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sierro-policy-page"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-sierro-policy]');

    roots.forEach((root) => {
      const links = Array.from(root.querySelectorAll('.sierro-policy__toc a'));
      const sections = links
        .map((link) => root.querySelector(link.getAttribute('href')))
        .filter(Boolean);

      if (!links.length || !sections.length || !('IntersectionObserver' in window)) return;

      const observer = new IntersectionObserver(
        (entries) => {
          const visible = entries
            .filter((entry) => entry.isIntersecting)
            .sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top)[0];

          if (!visible) return;

          links.forEach((link) => {
            const active = link.getAttribute('href') === `#${visible.target.id}`;
            link.classList.toggle('is-active', active);
            if (active) link.setAttribute('aria-current', 'true');
            else link.removeAttribute('aria-current');
          });
        },
        { rootMargin: '-18% 0px -70% 0px', threshold: [0, 0.1] },
      );

      sections.forEach((section) => observer.observe(section));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sierro-product-page"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-sierro-pdp]').forEach((section) => {
    const mainImage = section.querySelector('[data-sierro-main-image]');
    const mainMedia = section.querySelector('[data-sierro-main-media]');
    const thumbnails = section.querySelectorAll('[data-gallery-src]');
    const primaryForm = section.querySelector('.sierro-pdp__form');
    const stickyCart = section.querySelector('[data-sierro-sticky-cart]');
    const cartStatus = section.querySelector('[data-sierro-cart-status]');
    const addonStatus = section.querySelector('[data-sierro-addon-status]');
    const addonsButton = section.querySelector('[data-sierro-add-selected-addons]');
    const addonInputs = Array.from(section.querySelectorAll('[data-sierro-addon]'));
    let buyNowIntent = false;

    const syncAddonsButton = () => {
      if (!addonsButton) return;
      const selectedAddons = addonInputs.filter((input) => input.checked && !input.disabled);
      const includesDeviceOnlyAddon = selectedAddons.some((input) => input.hasAttribute('data-addon-requires-device'));
      addonsButton.disabled = !selectedAddons.length || includesDeviceOnlyAddon;
      addonsButton.textContent = includesDeviceOnlyAddon
        ? 'Use Add to cart above to include warranty'
        : 'Add selected accessories to cart';
    };

    addonInputs.forEach((input) => input.addEventListener('change', syncAddonsButton));
    syncAddonsButton();

    thumbnails.forEach((thumbnail) => {
      thumbnail.addEventListener('click', () => {
        if (!mainImage) return;

        mainImage.style.opacity = '0';
        window.setTimeout(() => {
          mainImage.src = thumbnail.dataset.gallerySrc;
          mainImage.alt = thumbnail.dataset.galleryAlt;
          mainMedia?.classList.toggle('is-product-render', thumbnail.dataset.galleryKind === 'product');
          mainImage.style.opacity = '1';
        }, 120);

        thumbnails.forEach((item) => {
          item.classList.remove('is-active');
          item.setAttribute('aria-pressed', 'false');
        });
        thumbnail.classList.add('is-active');
        thumbnail.setAttribute('aria-pressed', 'true');
      });
    });

    section.querySelectorAll('[data-sierro-qty]').forEach((quantity) => {
      const input = quantity.querySelector('input');
      const minus = quantity.querySelector('[data-qty-minus]');
      const plus = quantity.querySelector('[data-qty-plus]');

      minus?.addEventListener('click', () => {
        input.value = Math.max(1, Number(input.value || 1) - 1);
      });

      plus?.addEventListener('click', () => {
        input.value = Math.max(1, Number(input.value || 1) + 1);
      });
    });

    section.querySelectorAll('[data-preview-add]').forEach((button) => {
      button.addEventListener('click', () => {
        const note = section.querySelector('[data-preview-note]');
        if (note) note.hidden = false;
        note?.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      });
    });

    section.querySelectorAll('[data-backup-plan]').forEach((comparison) => {
      const dialog = comparison.querySelector('[data-appliances-dialog]');
      const openDialog = comparison.querySelector('[data-appliances-open]');
      const closeDialog = comparison.querySelector('[data-appliances-close]');
      const categoryTabs = Array.from(comparison.querySelectorAll('[data-appliance-category]'));
      const categoryPanels = Array.from(comparison.querySelectorAll('[data-appliance-panel]'));

      const selectCategory = (category, focusTab = false) => {
        categoryTabs.forEach((tab) => {
          const isActive = tab.dataset.applianceCategory === category;
          tab.classList.toggle('is-active', isActive);
          tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
          tab.tabIndex = isActive ? 0 : -1;
          if (isActive && focusTab) tab.focus();
        });

        categoryPanels.forEach((panel) => {
          panel.hidden = panel.dataset.appliancePanel !== category;
        });
      };

      categoryTabs.forEach((tab, index) => {
        tab.addEventListener('click', () => selectCategory(tab.dataset.applianceCategory));
        tab.addEventListener('keydown', (event) => {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          const nextIndex = (index + (event.key === 'ArrowRight' ? 1 : -1) + categoryTabs.length) % categoryTabs.length;
          selectCategory(categoryTabs[nextIndex].dataset.applianceCategory, true);
        });
      });

      const activeCategory = categoryTabs.find((tab) => tab.getAttribute('aria-selected') === 'true');
      selectCategory(activeCategory?.dataset.applianceCategory || 'kitchen');

      openDialog?.addEventListener('click', () => {
        if (!dialog) return;
        if (typeof dialog.showModal === 'function') dialog.showModal();
        else dialog.setAttribute('open', '');
        closeDialog?.focus();
      });

      closeDialog?.addEventListener('click', () => {
        if (!dialog) return;
        if (typeof dialog.close === 'function') dialog.close();
        else dialog.removeAttribute('open');
        openDialog?.focus();
      });

      dialog?.addEventListener('click', (event) => {
        if (event.target !== dialog) return;
        if (typeof dialog.close === 'function') dialog.close();
        else dialog.removeAttribute('open');
        openDialog?.focus();
      });
    });

    section.querySelectorAll('[data-sierro-app-carousel]').forEach((carousel) => {
      const panels = Array.from(carousel.querySelectorAll('[data-app-panel]'));
      const triggers = Array.from(carousel.querySelectorAll('[data-app-trigger]'));
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      let activeIndex = 0;
      let rotationTimer;

      const showPanel = (index, focusTrigger = false) => {
        activeIndex = (index + panels.length) % panels.length;

        panels.forEach((panel, panelIndex) => {
          const isActive = panelIndex === activeIndex;
          panel.hidden = !isActive;
          panel.classList.toggle('is-active', isActive);
        });

        triggers.forEach((trigger, triggerIndex) => {
          const isActive = triggerIndex === activeIndex;
          trigger.classList.toggle('is-active', isActive);
          trigger.setAttribute('aria-selected', isActive ? 'true' : 'false');
          trigger.tabIndex = isActive ? 0 : -1;
        });

        if (focusTrigger) triggers[activeIndex]?.focus();
      };

      const stopRotation = () => {
        window.clearInterval(rotationTimer);
      };

      const startRotation = () => {
        stopRotation();
        if (reduceMotion || panels.length < 2) return;
        rotationTimer = window.setInterval(() => showPanel(activeIndex + 1), 5000);
      };

      triggers.forEach((trigger, index) => {
        trigger.addEventListener('click', () => {
          showPanel(index);
          startRotation();
        });

        trigger.addEventListener('keydown', (event) => {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          showPanel(activeIndex + (event.key === 'ArrowRight' ? 1 : -1), true);
          startRotation();
        });
      });

      carousel.addEventListener('mouseenter', stopRotation);
      carousel.addEventListener('mouseleave', startRotation);
      carousel.addEventListener('focusin', stopRotation);
      carousel.addEventListener('focusout', startRotation);
      startRotation();
    });

    section.querySelector('[data-sierro-buy-now]')?.addEventListener('click', () => {
      buyNowIntent = true;
      const returnTo = primaryForm?.querySelector('[data-sierro-return-to]');
      if (returnTo) returnTo.value = '/checkout';
    });

    addonsButton?.addEventListener('click', async () => {
      const selectedAddons = addonInputs.filter((input) => input.checked && !input.disabled && !input.hasAttribute('data-addon-requires-device'));
      if (!selectedAddons.length) return;

      addonsButton.disabled = true;
      if (addonStatus) addonStatus.hidden = true;

      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: selectedAddons.map((addon) => ({ id: Number(addon.value), quantity: 1 }))
          })
        });
        if (!response.ok) throw new Error('Cart request failed');
        window.location.assign('/cart');
      } catch (error) {
        if (addonStatus) {
          addonStatus.textContent = 'One or more selected accessories could not be added. Please review your selections or try again later.';
          addonStatus.hidden = false;
        }
        syncAddonsButton();
      }
    });

    primaryForm?.addEventListener('submit', async (event) => {
      const selectedAddons = addonInputs.filter((input) => input.checked && !input.disabled);
      if (!selectedAddons.length) return;

      event.preventDefault();
      const submitter = event.submitter;
      const mainVariant = Number(primaryForm.querySelector('input[name="id"]')?.value);
      const quantity = Number(primaryForm.querySelector('input[name="quantity"]')?.value || 1);
      const items = [
        { id: mainVariant, quantity },
        ...selectedAddons.map((addon) => ({ id: Number(addon.value), quantity: 1 }))
      ];

      section.querySelectorAll('.sierro-pdp__form button, [data-sierro-sticky-cart] button').forEach((button) => {
        button.disabled = true;
      });
      if (cartStatus) cartStatus.hidden = true;

      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items })
        });
        if (!response.ok) throw new Error('Cart request failed');
        window.location.assign(buyNowIntent || submitter?.matches('[data-sierro-buy-now]') ? '/checkout' : '/cart');
      } catch (error) {
        buyNowIntent = false;
        if (cartStatus) {
          cartStatus.textContent = 'One or more selected accessories are not available yet. Please review your selections or try again later.';
          cartStatus.hidden = false;
        }
        section.querySelectorAll('.sierro-pdp__form button, [data-sierro-sticky-cart] button').forEach((button) => {
          button.disabled = false;
        });
      }
    });

    const updateStickyCart = () => {
      if (!primaryForm || !stickyCart) return;
      const headerHeight = Number.parseFloat(
        window.getComputedStyle(document.documentElement).getPropertyValue('--sierro-header-height')
      ) || 72;
      const shouldShow = primaryForm.getBoundingClientRect().bottom < headerHeight + 12;

      stickyCart.classList.toggle('is-visible', shouldShow);
      stickyCart.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
    };

    window.addEventListener('scroll', updateStickyCart, { passive: true });
    window.addEventListener('resize', updateStickyCart, { passive: true });
    updateStickyCart();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sierro-registration"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-sierro-registration]');

    const loadTurnstile = () => {
      if (window.turnstile) return Promise.resolve(window.turnstile);
      if (window.sierroTurnstileLoader) return window.sierroTurnstileLoader;

      window.sierroTurnstileLoader = new Promise((resolve, reject) => {
        document.querySelector('script[data-sierro-turnstile-api]')?.remove();
        const script = document.createElement('script');
        script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
        script.async = true;
        script.defer = true;
        script.dataset.sierroTurnstileApi = 'true';

        let settled = false;
        let timeoutId = null;
        const finish = (callback) => {
          if (settled) return;
          settled = true;
          window.clearTimeout(timeoutId);
          script.removeEventListener('load', handleLoad);
          script.removeEventListener('error', handleError);
          callback();
        };
        const fail = () => finish(() => {
          script.remove();
          reject(new Error('Security check could not be loaded.'));
        });
        const handleLoad = () => {
          if (window.turnstile) finish(() => resolve(window.turnstile));
          else fail();
        };
        const handleError = () => fail();

        script.addEventListener('load', handleLoad, { once: true });
        script.addEventListener('error', handleError, { once: true });
        timeoutId = window.setTimeout(fail, 12000);
        document.head.appendChild(script);
      });

      const loader = window.sierroTurnstileLoader;
      loader.catch(() => {
        if (window.sierroTurnstileLoader === loader) window.sierroTurnstileLoader = null;
      });

      return loader;
    };

    roots.forEach((root) => {
      if (root.dataset.sierroRegistrationReady === 'true') return;
      root.dataset.sierroRegistrationReady = 'true';

      const form = root.querySelector('[data-registration-preview-form]');
      if (!form) return;

      const productPicker = form.querySelector('[data-registration-product-picker]');
      const pickerQuantity = form.querySelector('[data-registration-picker-quantity]');
      const pickerMinus = form.querySelector('[data-registration-picker-minus]');
      const pickerPlus = form.querySelector('[data-registration-picker-plus]');
      const addItem = form.querySelector('[data-registration-add-item]');
      const itemsEmpty = form.querySelector('[data-registration-items-empty]');
      const itemsList = form.querySelector('[data-registration-items-list]');
      const itemsError = form.querySelector('[data-registration-items-error]');
      const itemsSummary = form.querySelector('[data-registration-items-summary]');
      const itemsPayload = form.querySelector('[data-registration-items-payload]');
      const powerTemplate = form.querySelector('[data-registration-power-template]');
      const accessoryTemplate = form.querySelector('[data-registration-accessory-template]');
      const submitLabel = form.querySelector('[data-registration-submit-label]');
      const purchaseDate = form.querySelector('[data-registration-purchase-date]');
      const deliveryDate = form.querySelector('[data-registration-delivery-date]');
      const proof = form.querySelector('[data-registration-proof]');
      const fileName = form.querySelector('[data-registration-file-name]');
      const termsAcknowledged = form.querySelector('[data-registration-terms-acknowledged]');
      const marketingConsent = form.querySelector('[data-registration-marketing-consent]');
      const termsAcceptedAt = form.querySelector('[data-registration-terms-accepted-at]');
      const marketingConsentVersion = form.querySelector('[data-registration-marketing-consent-version]');
      const marketingConsentAt = form.querySelector('[data-registration-marketing-consent-at]');
      const idempotencyKey = form.querySelector('[data-registration-idempotency-key]');
      const backendNote = form.querySelector('[data-registration-backend-note]');
      const successPanel = root.querySelector('[data-registration-success]');
      const confirmationId = root.querySelector('[data-registration-confirmation-id]');
      const confirmationEmailReceipt = root.querySelector('[data-registration-email-receipt]');
      const resetButton = root.querySelector('[data-registration-reset]');
      const submitButton = form.querySelector('.sierro-registration__submit');
      const endpoint = form.dataset.registrationEndpoint.trim();
      const turnstileSecurity = form.querySelector('[data-registration-security]');
      const turnstileContainer = form.querySelector('[data-registration-turnstile]');
      const turnstileNote = form.querySelector('[data-registration-security-note]');
      const turnstileRetry = form.querySelector('[data-registration-turnstile-retry]');
      const turnstileSiteKey = form.dataset.turnstileSiteKey.trim();
      const turnstileAction = form.dataset.turnstileAction.trim();
      const steps = Array.from(form.querySelectorAll('[data-registration-step]'));
      const nextButtons = form.querySelectorAll('[data-registration-next]');
      const backButtons = form.querySelectorAll('[data-registration-back]');
      const progressLabel = form.querySelector('[data-registration-progress-label]');
      const progressTitle = form.querySelector('[data-registration-progress-title]');
      const progressBar = form.querySelector('[data-registration-progress-bar]');

      let nextItemId = 1;
      let items = [];
      let currentStep = 1;
      let turnstileApi = null;
      let turnstileWidgetId = null;
      let turnstileToken = '';
      let turnstileInitialization = null;
      let turnstileReadyTimer = null;
      let isSubmitting = false;
      const stepTitles = ['Products', 'Purchase', 'Owner'];
      const confirmationIdPattern = /^SR-\d{8}-[A-F0-9]{16}$/;
      const defaultFileName = 'Add a receipt, invoice, or delivery record';

      const withRequestReference = (message, result, response) => {
        const requestId = String(result?.request_id || response?.headers?.get('X-Request-Id') || '').trim();
        return requestId ? `${message} Reference ID: ${requestId}` : message;
      };

      const showBackendNote = (message, kind = 'submission') => {
        backendNote.textContent = message;
        backendNote.dataset.noteKind = kind;
        backendNote.hidden = false;
      };

      const clearBackendNote = (kind = '') => {
        if (kind && backendNote.dataset.noteKind !== kind) return;
        backendNote.hidden = true;
        delete backendNote.dataset.noteKind;
      };

      const isWizard = () => true;

      const syncSubmitAvailability = () => {
        if (!submitButton) return;
        submitButton.disabled = isSubmitting;
      };

      const setTurnstileState = (state) => {
        if (turnstileContainer) turnstileContainer.dataset.turnstileState = state;
        if (turnstileSecurity) turnstileSecurity.dataset.turnstileState = state;
        if (turnstileNote) {
          const messages = {
            loading: 'Preparing security check…',
            rendering: 'Preparing security check…',
            rendered: 'Security check in progress…',
            interactive: 'Complete the security check shown above.',
            verified: 'Security check complete.',
            expired: 'Security check expired. Verifying again…',
            timeout: 'The security check is taking longer than expected. Please retry.',
            unsupported: 'This browser cannot run the security check. Try another browser or contact info@sierro.us.',
            error: 'The security check could not be loaded. Check content blockers, then retry.',
          };
          turnstileNote.textContent = messages[state] || 'Security check powered by Cloudflare Turnstile.';
        }
        if (turnstileRetry) {
          turnstileRetry.hidden = !['error', 'timeout', 'unsupported'].includes(state);
        }
        syncSubmitAvailability();
      };

      const clearTurnstileReadyTimer = () => {
        window.clearTimeout(turnstileReadyTimer);
        turnstileReadyTimer = null;
      };

      const startTurnstileReadyTimer = () => {
        clearTurnstileReadyTimer();
        turnstileReadyTimer = window.setTimeout(() => {
          if (!turnstileToken && currentStep === 3) setTurnstileState('timeout');
        }, 15000);
      };

      const resetTurnstile = () => {
        clearTurnstileReadyTimer();
        turnstileToken = '';
        if (turnstileApi && turnstileWidgetId !== null) {
          setTurnstileState('rendered');
          turnstileApi.reset(turnstileWidgetId);
          startTurnstileReadyTimer();
        } else {
          syncSubmitAvailability();
        }
      };

      const restartTurnstile = () => {
        clearTurnstileReadyTimer();
        turnstileToken = '';
        clearBackendNote('security');

        if (turnstileApi && turnstileWidgetId !== null && typeof turnstileApi.remove === 'function') {
          try {
            turnstileApi.remove(turnstileWidgetId);
          } catch (error) {
            // Continue with a clean container if the previous widget is already gone.
          }
        }

        turnstileWidgetId = null;
        turnstileInitialization = null;
        turnstileContainer?.replaceChildren();
        setTurnstileState('loading');
        return initializeTurnstile();
      };

      const initializeTurnstile = () => {
        if (!turnstileSiteKey || !turnstileContainer) return Promise.resolve();
        if (turnstileWidgetId !== null) return Promise.resolve(turnstileApi);
        if (turnstileInitialization) return turnstileInitialization;

        setTurnstileState('loading');
        turnstileInitialization = loadTurnstile()
          .then((api) => {
            turnstileApi = api;
            setTurnstileState('rendering');
            turnstileWidgetId = turnstileApi.render(turnstileContainer, {
              sitekey: turnstileSiteKey,
              action: turnstileAction,
              theme: 'light',
              size: 'flexible',
              appearance: 'interaction-only',
              execution: 'render',
              'response-field': false,
              retry: 'auto',
              'retry-interval': 8000,
              'refresh-expired': 'auto',
              'refresh-timeout': 'auto',
              callback: (token) => {
                clearTurnstileReadyTimer();
                turnstileToken = token;
                setTurnstileState('verified');
                clearBackendNote('security');
              },
              'expired-callback': () => {
                turnstileToken = '';
                setTurnstileState('expired');
                startTurnstileReadyTimer();
              },
              'timeout-callback': () => {
                turnstileToken = '';
                clearTurnstileReadyTimer();
                setTurnstileState('timeout');
              },
              'unsupported-callback': () => {
                turnstileToken = '';
                clearTurnstileReadyTimer();
                setTurnstileState('unsupported');
              },
              'before-interactive-callback': () => {
                if (!turnstileToken) setTurnstileState('interactive');
              },
              'after-interactive-callback': () => {
                if (!turnstileToken) setTurnstileState('rendered');
              },
              'error-callback': () => {
                turnstileToken = '';
                clearTurnstileReadyTimer();
                setTurnstileState('error');
              },
            });
            if (turnstileWidgetId === null || turnstileWidgetId === undefined) {
              throw new Error('Security check could not be rendered.');
            }
            if (turnstileContainer.dataset.turnstileState === 'rendering') {
              setTurnstileState('rendered');
            }
            startTurnstileReadyTimer();
            return turnstileApi;
          })
          .catch((error) => {
            clearTurnstileReadyTimer();
            turnstileInitialization = null;
            turnstileWidgetId = null;
            setTurnstileState('error');
            return null;
          });

        return turnstileInitialization;
      };

      const createIdempotencyKey = () => {
        if (typeof window.crypto?.randomUUID === 'function') {
          return window.crypto.randomUUID();
        }

        if (typeof window.crypto?.getRandomValues !== 'function') return '';
        const bytes = window.crypto.getRandomValues(new Uint8Array(16));
        bytes[6] = (bytes[6] & 0x0f) | 0x40;
        bytes[8] = (bytes[8] & 0x3f) | 0x80;
        const hex = Array.from(bytes, (byte) => byte.toString(16).padStart(2, '0')).join('');
        return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
      };

      const renewIdempotencyKey = () => {
        idempotencyKey.value = createIdempotencyKey();
      };

      const syncDateConstraints = () => {
        deliveryDate.min = purchaseDate.value || '';
      };

      const showStep = (stepNumber, shouldFocus = false) => {
        currentStep = Math.min(3, Math.max(1, stepNumber));

        steps.forEach((step) => {
          step.hidden = Number(step.dataset.registrationStep) !== currentStep;
        });

        if (progressLabel) progressLabel.textContent = `Step ${currentStep} of 3`;
        if (progressTitle) progressTitle.textContent = stepTitles[currentStep - 1];
        if (progressBar) progressBar.style.width = `${currentStep * 33.333}%`;

        if (currentStep === 3 && turnstileWidgetId === null) {
          window.requestAnimationFrame(() => initializeTurnstile());
        }

        if (shouldFocus) {
          const activeStep = steps.find((step) => Number(step.dataset.registrationStep) === currentStep);
          const heading = activeStep?.querySelector('.sierro-registration__form-topline p');
          window.requestAnimationFrame(() => {
            root.querySelector('.sierro-registration__form-panel')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
            heading?.setAttribute('tabindex', '-1');
            heading?.focus({ preventScroll: true });
          });
        }
      };

      const normalizeSerialInput = (input) => {
        const serialNumber = input.value.trim().toUpperCase();
        const itemId = Number(input.closest('[data-registration-item]')?.dataset.registrationItemId);
        const item = items.find((entry) => entry.id === itemId);

        input.value = serialNumber;
        if (item) item.serial = serialNumber;

        return serialNumber;
      };

      const validateSerialInput = (input) => {
        const serialNumber = normalizeSerialInput(input);
        let message = '';

        if (!serialNumber) {
          message = 'Enter the serial number for this unit.';
        } else if (serialNumber.length < 4) {
          message = 'Enter the complete serial number shown on this unit.';
        } else if (!serialNumber.startsWith('SN')) {
          message = 'Enter a serial number that starts with SN.';
        }

        input.setCustomValidity(message);
      };

      const validateStep = (stepNumber) => {
        const step = steps.find((entry) => Number(entry.dataset.registrationStep) === stepNumber);
        if (!step) return true;

        if (stepNumber === 1 && itemTotal() === 0) {
          itemsError.textContent = 'Add at least one product or accessory to continue.';
          itemsError.hidden = false;
          productPicker.focus();
          return false;
        }

        if (stepNumber === 1) {
          step.querySelectorAll('[data-registration-item-serial]').forEach((input) => {
            validateSerialInput(input);
          });
          syncPayload();
        }

        if (stepNumber === 2) {
          purchaseDate.setCustomValidity(
            purchaseDate.value && purchaseDate.max && purchaseDate.value > purchaseDate.max
              ? 'Purchase date cannot be in the future.'
              : ''
          );

          let deliveryDateError = '';
          if (deliveryDate.value && deliveryDate.max && deliveryDate.value > deliveryDate.max) {
            deliveryDateError = 'Date received cannot be in the future.';
          } else if (deliveryDate.value && purchaseDate.value && deliveryDate.value < purchaseDate.value) {
            deliveryDateError = 'Date received cannot be earlier than the purchase date.';
          }
          deliveryDate.setCustomValidity(deliveryDateError);
        }

        const invalid = Array.from(step.querySelectorAll('input, select')).find(
          (field) => !field.disabled && !field.checkValidity()
        );

        if (invalid) {
          invalid.reportValidity();
          return false;
        }

        return true;
      };

      const clampQuantity = (value) => {
        const number = Number.parseInt(value, 10);
        if (Number.isNaN(number)) return 1;
        return Math.min(20, Math.max(1, number));
      };

      const syncPayload = () => {
        itemsPayload.value = JSON.stringify(
          items.map((item) => ({
            product: item.product,
            product_name: item.label,
            product_type: item.kind,
            quantity: item.kind === 'accessory' ? item.quantity : 1,
            serial_number: item.kind === 'power-station' ? item.serial : null,
          }))
        );
      };

      const itemTotal = () =>
        items.reduce((total, item) => total + (item.kind === 'accessory' ? item.quantity : 1), 0);

      const renderSummary = () => {
        const powerCount = items.filter((item) => item.kind === 'power-station').length;
        const accessoryCount = items
          .filter((item) => item.kind === 'accessory')
          .reduce((total, item) => total + item.quantity, 0);
        const total = powerCount + accessoryCount;
        const parts = [];

        if (powerCount > 0) {
          parts.push(`${powerCount} power ${powerCount === 1 ? 'station' : 'stations'}`);
        }
        if (accessoryCount > 0) {
          parts.push(`${accessoryCount} ${accessoryCount === 1 ? 'accessory' : 'accessories'}`);
        }

        itemsSummary.textContent = parts.length > 0 ? parts.join(', ') : 'No items added';
        submitLabel.textContent = total > 0
          ? `Register ${total} ${total === 1 ? 'item' : 'items'}`
          : 'Register products';
      };

      const updateAccessoryQuantity = (itemId, quantity) => {
        const item = items.find((entry) => entry.id === itemId);
        if (!item) return;
        item.quantity = clampQuantity(quantity);
        renderItems();
      };

      const removeItem = (itemId) => {
        items = items.filter((item) => item.id !== itemId);
        renderItems();
      };

      const renderItems = () => {
        itemsList.innerHTML = '';
        itemsEmpty.hidden = items.length > 0;
        const unitNumbers = {};

        items.forEach((item) => {
          const template = item.kind === 'power-station' ? powerTemplate : accessoryTemplate;
          const card = template.content.firstElementChild.cloneNode(true);
          card.dataset.registrationItemId = item.id;

          const title = card.querySelector('[data-registration-item-title]');
          const removeButton = card.querySelector('[data-registration-remove-item]');
          removeButton.addEventListener('click', () => removeItem(item.id));

          if (item.kind === 'power-station') {
            unitNumbers[item.product] = (unitNumbers[item.product] || 0) + 1;
            title.textContent = `${item.label} - Unit ${unitNumbers[item.product]}`;

            const serialInput = card.querySelector('[data-registration-item-serial]');
            const serialLabel = card.querySelector('[data-registration-item-serial-label]');
            const serialNote = card.querySelector('[data-registration-item-serial-note]');
            const serialId = `sierro-registration-serial-${item.id}`;
            const serialNoteId = `${serialId}-note`;

            serialInput.id = serialId;
            serialInput.name = `registration_item_${item.id}_serial_number`;
            serialInput.value = item.serial;
            serialInput.setAttribute('aria-describedby', serialNoteId);
            serialLabel.htmlFor = serialId;
            serialNote.id = serialNoteId;

            serialInput.addEventListener('input', () => {
              item.serial = serialInput.value;
              serialInput.setCustomValidity('');
              syncPayload();
            });
            serialInput.addEventListener('blur', () => {
              validateSerialInput(serialInput);
              syncPayload();
            });
          } else {
            title.textContent = item.label;
            const quantityInput = card.querySelector('[data-registration-item-quantity]');
            const minusButton = card.querySelector('[data-registration-item-minus]');
            const plusButton = card.querySelector('[data-registration-item-plus]');

            quantityInput.name = `registration_item_${item.id}_quantity`;
            quantityInput.value = item.quantity;
            minusButton.disabled = item.quantity <= 1;
            plusButton.disabled = item.quantity >= 20;

            minusButton.addEventListener('click', () => updateAccessoryQuantity(item.id, item.quantity - 1));
            plusButton.addEventListener('click', () => updateAccessoryQuantity(item.id, item.quantity + 1));
            quantityInput.addEventListener('change', () => updateAccessoryQuantity(item.id, quantityInput.value));
          }

          itemsList.appendChild(card);
        });

        if (items.length > 0) itemsError.hidden = true;
        renderSummary();
        syncPayload();
      };

      const addSelectedItems = () => {
        const selected = productPicker.options[productPicker.selectedIndex];
        const kind = selected?.dataset.kind;

        if (!kind) {
          itemsError.textContent = 'Select a product before adding it.';
          itemsError.hidden = false;
          productPicker.focus();
          return;
        }

        const quantity = clampQuantity(pickerQuantity.value);
        const product = selected.value;
        const label = selected.textContent.trim();

        if (kind === 'power-station') {
          for (let index = 0; index < quantity; index += 1) {
            items.push({
              id: nextItemId,
              product,
              label,
              kind,
              serial: '',
            });
            nextItemId += 1;
          }
        } else {
          const existing = items.find((item) => item.kind === 'accessory' && item.product === product);
          if (existing) {
            existing.quantity = clampQuantity(existing.quantity + quantity);
          } else {
            items.push({
              id: nextItemId,
              product,
              label,
              kind,
              quantity,
            });
            nextItemId += 1;
          }
        }

        productPicker.selectedIndex = 0;
        pickerQuantity.value = 1;
        itemsError.hidden = true;
        renderItems();
      };

      pickerMinus.addEventListener('click', () => {
        pickerQuantity.value = clampQuantity(Number(pickerQuantity.value) - 1);
      });
      pickerPlus.addEventListener('click', () => {
        pickerQuantity.value = clampQuantity(Number(pickerQuantity.value) + 1);
      });
      pickerQuantity.addEventListener('change', () => {
        pickerQuantity.value = clampQuantity(pickerQuantity.value);
      });
      addItem.addEventListener('click', addSelectedItems);

      nextButtons.forEach((button) => {
        button.addEventListener('click', () => {
          const step = Number(button.closest('[data-registration-step]')?.dataset.registrationStep || currentStep);
          if (!validateStep(step)) return;
          showStep(step + 1, true);
        });
      });

      backButtons.forEach((button) => {
        button.addEventListener('click', () => {
          const step = Number(button.closest('[data-registration-step]')?.dataset.registrationStep || currentStep);
          showStep(step - 1, true);
        });
      });

      turnstileRetry?.addEventListener('click', () => {
        restartTurnstile();
      });

      purchaseDate.addEventListener('change', () => {
        purchaseDate.setCustomValidity('');
        deliveryDate.setCustomValidity('');
        syncDateConstraints();
      });

      deliveryDate.addEventListener('change', () => {
        deliveryDate.setCustomValidity('');
      });

      proof.addEventListener('change', () => {
        const selectedFile = proof.files?.[0];
        if (selectedFile && selectedFile.size > 20 * 1024 * 1024) {
          proof.setCustomValidity('Upload a file smaller than 20 MB.');
        } else {
          proof.setCustomValidity('');
        }
        fileName.textContent = selectedFile?.name || defaultFileName;
      });

      resetButton?.addEventListener('click', () => {
        form.reset();
        items = [];
        nextItemId = 1;
        purchaseDate.setCustomValidity('');
        deliveryDate.setCustomValidity('');
        proof.setCustomValidity('');
        fileName.textContent = defaultFileName;
        termsAcceptedAt.value = '';
        marketingConsentVersion.value = '';
        marketingConsentAt.value = '';
        syncDateConstraints();
        renewIdempotencyKey();
        resetTurnstile();
        clearBackendNote();
        if (confirmationEmailReceipt) confirmationEmailReceipt.hidden = true;
        successPanel.hidden = true;
        form.hidden = false;
        renderItems();
        showStep(1);
        root.querySelector('.sierro-registration__form-panel')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });

      form.addEventListener('submit', async (event) => {
        event.preventDefault();

        if (itemTotal() === 0) {
          itemsError.textContent = 'Add at least one product or accessory to continue.';
          itemsError.hidden = false;
          productPicker.focus();
          return;
        }

        form.querySelectorAll('[data-registration-item-serial]').forEach((input) => {
          validateSerialInput(input);
        });
        syncPayload();

        for (let stepNumber = 1; stepNumber <= 3; stepNumber += 1) {
          if (!validateStep(stepNumber)) {
            showStep(stepNumber);
            window.requestAnimationFrame(() => validateStep(stepNumber));
            return;
          }
        }

        if (!endpoint) {
          showBackendNote('Secure submission is not connected yet. Please contact info@sierro.us.', 'configuration');
          backendNote.focus();
          return;
        }

        const originalLabel = submitLabel.textContent;
        isSubmitting = true;
        syncSubmitAvailability();
        submitLabel.textContent = 'Submitting...';
        clearBackendNote();
        let submissionSucceeded = false;

        try {
          const consentTimestamp = new Date().toISOString();
          termsAcceptedAt.value = termsAcknowledged.checked ? consentTimestamp : '';
          marketingConsentVersion.value = marketingConsent.checked
            ? marketingConsentVersion.dataset.version
            : '';
          marketingConsentAt.value = marketingConsent.checked ? consentTimestamp : '';

          if (!idempotencyKey.value) renewIdempotencyKey();
          if (!idempotencyKey.value) {
            throw new Error('Secure submission could not be prepared. Please reload the page and try again.');
          }

          const formData = new FormData(form);
          formData.set('registration_items', itemsPayload.value);
          formData.set('source', 'sierro-shopify');

          const requestHeaders = { Accept: 'application/json' };
          if (turnstileToken) requestHeaders['X-Turnstile-Token'] = turnstileToken;

          const response = await fetch(endpoint, {
            method: 'POST',
            body: formData,
            headers: requestHeaders,
          });
          const result = await response.json().catch(() => ({}));

          if (!response.ok) {
            throw new Error(
              withRequestReference(
                result.error || 'Registration could not be submitted.',
                result,
                response
              )
            );
          }

          if (!confirmationIdPattern.test(result.registration_id || '')) {
            throw new Error(
              withRequestReference(
                'We could not verify the registration confirmation. Please try again or contact info@sierro.us.',
                result,
                response
              )
            );
          }

          confirmationId.textContent = result.registration_id;
          if (confirmationEmailReceipt) {
            confirmationEmailReceipt.hidden = result.confirmation_email !== 'sent';
          }
          window.sierroPublish?.('registration_submitted', {
            product_count: itemTotal(),
            page_path: window.location.pathname,
          });
          form.hidden = true;
          successPanel.hidden = false;
          submissionSucceeded = true;
          successPanel.focus();
          successPanel.scrollIntoView({ behavior: 'smooth', block: 'center' });
        } catch (error) {
          showBackendNote(error.message || 'Registration could not be submitted. Please try again.');
          backendNote.focus();
        } finally {
          if (!submissionSucceeded) resetTurnstile();
          isSubmitting = false;
          syncSubmitAvailability();
          submitLabel.textContent = originalLabel;
        }
      });

      if (turnstileSiteKey) loadTurnstile().catch(() => null);
      syncSubmitAvailability();
      renewIdempotencyKey();
      syncDateConstraints();
      renderItems();
      showStep(1);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sierro-support"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-sierro-support]');

    roots.forEach((root) => {
      if (root.dataset.sierroSupportReady === 'true') return;
      root.dataset.sierroSupportReady = 'true';

      const tabs = Array.from(root.querySelectorAll('[data-support-tab]'));
      const panels = Array.from(root.querySelectorAll('[data-support-panel]'));

      const selectTab = (key, moveFocus = false) => {
        tabs.forEach((tab) => {
          const selected = tab.dataset.supportTab === key;
          tab.setAttribute('aria-selected', String(selected));
          tab.setAttribute('tabindex', selected ? '0' : '-1');
          if (selected && moveFocus) tab.focus();
        });

        panels.forEach((panel) => {
          panel.hidden = panel.dataset.supportPanel !== key;
        });
      };

      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => selectTab(tab.dataset.supportTab));
        tab.addEventListener('keydown', (event) => {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          const direction = event.key === 'ArrowRight' ? 1 : -1;
          const nextIndex = (index + direction + tabs.length) % tabs.length;
          selectTab(tabs[nextIndex].dataset.supportTab, true);
        });
      });

      root.querySelectorAll('.sierro-support__faq details').forEach((detail) => {
        detail.addEventListener('toggle', () => {
          if (!detail.open) return;
          detail.parentElement?.querySelectorAll('details[open]').forEach((sibling) => {
            if (sibling !== detail) sibling.open = false;
          });
        });
      });

      root.querySelectorAll('[data-sierro-support-email]').forEach((link) => {
        link.addEventListener('click', () => {
          window.sierroPublish?.('support_email_clicked', { page_path: window.location.pathname });
        });
      });

      selectTab('start');
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sierro-volume-orders"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-sierro-volume]').forEach((section) => {
    const params = new URLSearchParams(window.location.search);
    const model = section.querySelector('[data-volume-model]');
    const requestedModel = params.get('model');
    const modelValues = {
      'sierro-1000': 'Sierro 1000',
      'sierro-2000': 'Sierro 2000'
    };

    if (model && !model.value && modelValues[requestedModel]) model.value = modelValues[requestedModel];

    let savedUtm = {};
    try {
      savedUtm = JSON.parse(sessionStorage.getItem('sierro:acquisition-utms') || '{}');
    } catch (_) {}

    section.querySelectorAll('[data-volume-utm]').forEach((input) => {
      input.value = params.get(input.dataset.volumeUtm) || savedUtm[input.dataset.volumeUtm] || '';
    });

    const landingPage = section.querySelector('[data-volume-landing-page]');
    if (landingPage) landingPage.value = window.location.href;

    const feedback = section.querySelector('[data-volume-feedback]');
    const form = section.querySelector('form');
    const draftKey = 'sierro:volume-order-draft';

    if (feedback?.dataset.volumeResult === 'success') {
      try {
        sessionStorage.removeItem(draftKey);
      } catch (_) {}
    }

    if (feedback?.dataset.volumeResult === 'error' && form) {
      try {
        const draft = JSON.parse(sessionStorage.getItem(draftKey) || '{}');
        form.querySelectorAll('input:not([type="hidden"]), select, textarea').forEach((field) => {
          if (draft[field.name] !== undefined) field.value = draft[field.name];
        });
      } catch (_) {}
    }

    form?.addEventListener('submit', () => {
      const draft = {};
      form.querySelectorAll('input:not([type="hidden"]), select, textarea').forEach((field) => {
        draft[field.name] = field.value;
      });
      try {
        sessionStorage.setItem(draftKey, JSON.stringify(draft));
      } catch (_) {}
    });

    if (feedback) requestAnimationFrame(() => feedback.focus());
  });

  } catch(e) { console.error(e); }
})();
})();
